import React from 'react';

/**
 * PhaseProgressBar - 21-segment progress strip for the checklist/MCDU phase pages.
 * Driven entirely by live phase data (order_index, is_complete) - no hardcoded slugs.
 * Completed phases = green (#2F8F57). Current phase = cyan, or green if it is itself
 * complete. Future phases = muted (#1E2735).
 */
const PhaseProgressBar = (props) => {
  const phases = props.phases || [];
  const currentOrderIndex = props.currentOrderIndex;

  if (!phases.length) return null;

  return (
    <div
      className="flex gap-1"
      role="group"
      aria-label={`Flight progress: phase ${currentOrderIndex} of ${phases.length}`}
      data-testid="phase-progress-bar"
    >
      {phases.map((p) => {
        let bg = '#1E2735';
        if (p.order_index < currentOrderIndex) {
          bg = 'var(--gc-green-segment)';
        } else if (p.order_index === currentOrderIndex) {
          bg = p.is_complete ? 'var(--gc-green)' : 'var(--gc-cyan)';
        }
        return (
          <div
            key={p.id || p.slug}
            className="flex-1 h-1.5 rounded-sm transition-colors duration-300"
            style={{ background: bg }}
            data-testid={`progress-segment-${p.order_index}`}
          />
        );
      })}
    </div>
  );
};

export default PhaseProgressBar;
